<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_7154_22926)">
      <path d="M41.4201 16.237V35.057C41.4201 39.977 37.4001 43.997 32.4801 43.997H15.5201C10.6001 43.997 6.58008 39.977 6.58008 35.057V16.237C6.58008 12.817 8.50008 9.83703 11.3201 8.33703C12.3001 7.81703 13.5201 8.51703 13.5201 9.63703C13.5201 12.817 16.1201 15.417 19.3001 15.417H28.7001C31.8801 15.417 34.4801 12.817 34.4801 9.63703C34.4801 8.51703 35.6801 7.81703 36.6801 8.33703C39.5001 9.83703 41.4201 12.817 41.4201 16.237Z" fill="#FECBD4" />
      <path d="M28.7005 4H19.3005C17.2205 4 15.5205 5.68 15.5205 7.76V9.64C15.5205 11.72 17.2005 13.4 19.2805 13.4H28.7005C30.7805 13.4 32.4605 11.72 32.4605 9.64V7.76C32.4805 5.68 30.7805 4 28.7005 4Z" fill="#FECBD4" />
    </g>
    <defs>
      <filter id="filter0_i_7154_22926" x="0" y="0" width="48" height="49.4286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1.42857" />
        <feGaussianBlur stdDeviation="1.42857" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_7154_22926" />
      </filter>
    </defs>
  </svg>
</template>
